export default "/images/vendor/flag-icon-css/flags/1x1/ki.svg?93b60ad98e05bc97b906edcd1335e329";